import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'

import pic05 from '../assets/images/pic05.jpg'

const Baguettes = (props) => (
    <Layout>
        <Helmet>
            <title>Baguettes</title>
            <meta name="description" content="Baguettes" />
            <html lang="en"/>
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h1>Baguettes</h1>
                    </header>
                    <div className="grid-wrapper">
                        <span className="image fit col-6"><img src={pic05} alt="Baguettes" /></span>
                        <p className="col-6">A baguette is a long, narrow French loaf of bread. They're great for sandwiches!</p>
                    </div>
                </div>
            </section>
        </div>

    </Layout>
)

export default Baguettes